/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserResourceProgress } from './userResourceProgress';

export type ResourceProgress = UserResourceProgress | null;
